// apps/homepage/src/im/client/index.ts
import { IUserEventMap, user } from '@app/model';
import { Log, toProxy } from '@fanfanlo';
import { matrixClient } from './client';
import { ICreateClientOpts, LoginRequest, LoginResponse, MatrixClient } from 'matrix-js-sdk';
export interface IMatrixUserInfo{
    loginResponse:LoginResponse|undefined
}

const userInfo:IMatrixUserInfo = toProxy({
    loginResponse:undefined
})

const userData = toProxy({
    userInfo,
})
const fileLogger = new Log(false, 'im.client.user');
fileLogger.childrenPaused = true;
async function onUserChanged() {
    const logger = fileLogger.sub(false,'onUserChanged_fn');
    logger.pause = true;
    logger.log('onUserChanged', user.data.imAppUserData?.homeserverUrl);
    if(!user.data.imAppUserData?.homeserverUrl){
        logout();
        return;
    }
    resetClient();
}
async function logout(){
    const log = fileLogger.sub(false, 'logout_fn');
    log.log('logout');
    matrixClient.client?.stopClient();
}
async function resetClient(){
    userInfo.loginResponse = undefined;
    const log = fileLogger.sub(false, 'resetClient_fn');
    log.pause = true;
    try{
        const clientOpts = getClientOpts();
        log.log('clientOpts=', clientOpts)
        if(!clientOpts){
            return;
        }
        const opts:ICreateClientOpts = {
            baseUrl: clientOpts.homeserverUrl,
            
        }
        let client = await matrixClient.createLoginClient(opts);
        log.log('client created')
        const loginOpts:LoginRequest = {
            type:"m.login.password",
            password:clientOpts.userPw,
            user:clientOpts.userName
        }
        const available = await client.isUsernameAvailable(clientOpts.userName);
        log.log('available=', available)
        if(available){
            const opts = {
                username:clientOpts.userName,
                password:clientOpts.userPw,
            }
            // await registerUser(client, clientOpts.userName, clientOpts.userPw);
            await registerUser2(clientOpts.homeserverUrl, clientOpts.userName, clientOpts.userPw);
            // const registerResponse = await client.registerRequest(opts);
            // log.log('registerResponse=', registerResponse)
        }
        const loginResult = await client.loginRequest(loginOpts)
        log.log('loginresult=', loginResult);
        userInfo.loginResponse = loginResult;
        client = await matrixClient.createProxyClient({
            baseUrl:clientOpts.homeserverUrl,
            accessToken: loginResult.access_token,
            userId: loginResult.user_id,
            deviceId: loginResult.device_id,
        });

        client.startClient();
    }catch(error){
        log.error('resetClient error=', error)
        throw error;
    }
}

async function registerUser(client:MatrixClient, username:string, pw:string) {
    const logger= fileLogger.sub(false, 'registerUser_fn');
    logger.pause = true;
    try {
        // 第一次尝试注册
        const registerResponse = await client.registerRequest({
            username:username,
            password:pw,
        });
        logger.log("注册成功 (无需 UIA):", registerResponse);
    } catch (err) {
        // 捕获错误，检查是否是 UIA 挑战
        if ((err as any).httpStatus === 401 && (err as any).data && (err as any).data.flows) {
            const session = (err as any).data.session;
            const flows = (err as any).data.flows;

            logger.log("注册需要用户交互认证 (UIA)。");
            logger.log("会话ID:", session);
            logger.log("支持的认证流程:", flows);

        // **新增的详细日志，请务必打印这些！**
        logger.log(">>>> 正在处理的 flows 数组：", flows);
        flows.forEach((flowItem:any, index:any) => {
            logger.log(`  >>>> 遍历 flows[${index}]:`, flowItem);
            if (flowItem && flowItem.stages) {
                logger.log(`    >>>> flows[${index}].stages:`, flowItem.stages);
                logger.log(`    >>>> flows[${index}].stages 是否包含 "m.login.dummy":`, flowItem.stages.includes("m.login.dummy"));
            } else {
                logger.log(`    >>>> flows[${index}] 或其 stages 属性不符合预期。`);
            }
        });

        const dummyFlow = flows.find((flow:any) => flow.stages && flow.stages.includes("m.login.dummy"));
        
        // **关键日志：查看 find 结果**
        logger.log(">>>> dummyFlow find 操作的结果是:", dummyFlow);

            if (dummyFlow) {
                logger.log("检测到 m.login.dummy 认证阶段，再次尝试注册...");
                try {
                    // 第二次尝试注册，这次包含 auth 对象
                    const finalRegisterResponse = await matrixClient.client?.registerRequest({
                        username:username,
                        password:pw,
                        auth:{
                            session: session,
                            type: "m.login.dummy"
                        }
                    });
                    console.log("注册成功 (通过 m.login.dummy UIA):", finalRegisterResponse);
                } catch (retryErr) {
                    console.error("第二次注册请求失败 (UIA 阶段):", retryErr);
                }
            } else {
                console.error("Homeserver 需要未支持的 UIA 阶段:", flows);
            }
        } else {
            console.error("注册失败 (非 UIA 错误):", err);
        }
    }
}

export async function registerUser2(homeserverUrl: string, username: string, password: string) {
    const client: MatrixClient = await matrixClient.createLoginClient({
      baseUrl: homeserverUrl,
    });
  
    try {
      // 第一次尝试注册（不带 auth）—— 预期 401，获取 session
      await client.registerRequest({ username, password });
      throw new Error("Unexpected success — homeserver didn't request UIA flow.");
    } catch (err: any) {
      if (err?.data?.session && Array.isArray(err.data.flows)) {
        const sessionId = err.data.session;
  
        // 只支持 m.login.dummy 的情况
        const hasDummy = err.data.flows.some((f: any) =>
          f.stages.includes("m.login.dummy")
        );
        if (!hasDummy) {
          throw new Error("Server does not support m.login.dummy. Cannot proceed.");
        }
  
        // 第二次请求，带上 auth
        const response = await client.registerRequest({
          username,
          password,
          auth: {
            type: "m.login.dummy",
            session: sessionId,
          },
        });
  
        // 注册成功
        return {
          accessToken: response.access_token,
          userId: response.user_id,
          deviceId: response.device_id,
        };
      } else {
        throw new Error("Unexpected registration error: " + JSON.stringify(err.data || err));
      }
    }
  }
  
function getClientOpts() {
    let userName = '';
    let userPw = '';
    const homeserverUrl = user.data.imAppUserData?.homeserverUrl;
    if(!homeserverUrl){
        console.error('No homeserver url available');
        return;
    }
    if (user.data.storeData.user_token) {
        const userInfo = user.data.sessionData.prime_user_info;
        if (!userInfo) {
            console.error('No user info available');
            return;
        }
        if (!userInfo.im_matrix_user_id) {
            console.error('No user id');
            return;
        }
        if (!userInfo.im_matrix_pw) {
            console.error("NO user pw")
            return;
        }
        userName = userInfo.im_matrix_user_id;
        userPw = userInfo.im_matrix_pw
    } else {
        const visit = user.data.sessionData.visit
        if (!visit) {
            console.error('No visit info available');
            return;
        }
        if (!visit.im_matrix_user_id) {
            console.error('No user id');
            return;
        }
        if (!visit.im_matrix_pw) {
            console.error("NO user pw")
            return;
        }
        userName = visit.im_matrix_user_id;
        userPw = visit.im_matrix_pw
    }
    if (!userName) {
        console.error('No user token or device ID available');
        return;
    }
    return { userName, userPw, homeserverUrl }
}

async function listen() {
    user.addListener<IUserEventMap>('onUserChanged', onUserChanged)
}

async function init(){
    listen();
}
export const matrixUser = {
    init,
    userData,
}